import { Flex, Shape, SubTitle, Body, Switch } from '@teko/ds-mobile';
import React from 'react';
import { t } from 'i18n';
import { useDistanceTerminalContext } from 'contexts';
import { useGetDistanceTerminal } from '../useGetDistanceTerminal';

export const SwitchGetByGeoLocation = () => {
  const {
    isGetCurrentLocation,
    setIsGetCurrentLocation,
    setIsModeEnterAddress,
  } = useDistanceTerminalContext();
  const { requestLocation } = useGetDistanceTerminal();

  return (
    <Shape>
      <Flex align="start">
        <Shape>
          <SubTitle level={1}>
            {t('Bật định vị – nhận ưu đãi đúng chỗ!')}
          </SubTitle>
          <Body level={1}>
            {t(`Cho phép truy cập vị trí để tìm siêu thị gần nhất.`)}
          </Body>
          <Body level={1}>
            {t(
              `Miễn phí vận chuyển trong phạm vi 6km với đơn hàng từ 200.000 đồng.`,
            )}
          </Body>
        </Shape>
        <Shape>
          <Switch
            checked={isGetCurrentLocation}
            onChange={() => {
              if (isGetCurrentLocation) {
                setIsGetCurrentLocation?.(false);
                setIsModeEnterAddress?.(true);
              } else {
                requestLocation(() => setIsGetCurrentLocation?.(true));
              }
            }}
          />
        </Shape>
      </Flex>
    </Shape>
  );
};
